import { Box, Grid } from '@mui/material'
import { CommonLabelProps, ContentWrapper, ContentWrapperProps, Label } from '.'
import { useIsMobile } from '../contexts'

export interface LabeledItemProps
  extends Partial<Pick<ContentWrapperProps, 'showContent'>>,
    Pick<ContentWrapperProps, 'children'>,
    CommonLabelProps {
  labelId?: string
}

export const LabeledItem = ({
  children,
  labelId,
  showContent = true,
  ...labelProps
}: LabeledItemProps) => {
  const isMobile = useIsMobile()

  return (
    <ContentWrapper showContent={showContent}>
      <Grid container>
        <Grid item md={12} xs={12}>
          <Label
            inputLabelProps={{
              id: labelId,
              sx: { mb: isMobile ? '3px' : '8px' }
            }}
            {...labelProps}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <Box sx={{ mb: isMobile ? '15px' : undefined }}> {children}</Box>
        </Grid>
      </Grid>
    </ContentWrapper>
  )
}
